import { z } from 'zod';
import { coordinateSchema, sizeSchema } from '../../../Shared.js';
import { polygonVertexSchema } from '../../PolygonVertex.js';
import { numberSchema } from '../schemas.js';

const baseSchema = z.object({
  kind: z.literal("legacyCanvasShape"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  naturalSize: sizeSchema,
  angleInRadian: z.number(),
  settings: z.object({
    cloneable: z.boolean().default(false),
    movable: z.boolean().default(false),
    hideDragHandle: z.boolean().optional()
  }).default({}),
  style: z.object({
    background: z.object({
      color: z.string(),
      opacity: z.number().optional()
    }),
    stroke: z.object({
      type: z.string().default("solid"),
      color: z.string().default("#000"),
      width: numberSchema(1)
    })
  }).default({
    background: { color: "#fff" },
    stroke: { type: "solid", color: "#000", width: 1 }
  })
});
const legacyCanvasPolygonShapeItemSchema = baseSchema.extend({
  type: z.literal("polygon"),
  vertices: z.array(polygonVertexSchema)
});
const legacyCanvasRectangleShapeItemSchema = baseSchema.extend({
  type: z.literal("rectangle")
});
const legacyCanvasCircleShapeItemSchema = baseSchema.extend({
  type: z.literal("circle"),
  radius: z.number()
});
const legacyCanvasShapeItemSchema = z.discriminatedUnion("type", [
  legacyCanvasPolygonShapeItemSchema,
  legacyCanvasRectangleShapeItemSchema,
  legacyCanvasCircleShapeItemSchema
]);

export { legacyCanvasShapeItemSchema };
//# sourceMappingURL=LegacyCanvasShape.js.map
